<script setup>
import { computed, defineModel } from 'vue';
import { useI18n } from 'vue-i18n';

const modelValue = defineModel({
  type: String,
  default: 'conversations',
});

const { t } = useI18n();

const items = computed(() => [
  {
    key: 'conversations',
    label: t('MONITOR_PAGE.VIEWS.CONVERSATIONS'),
    icon: 'chat',
  },
  {
    key: 'search',
    label: t('MONITOR_PAGE.VIEWS.SEARCH'),
    icon: 'search',
  },
  {
    key: 'gallery',
    label: t('MONITOR_PAGE.VIEWS.GALLERY'),
    icon: 'image',
  },
]);
</script>

<template>
  <div class="relative z-10 border-b border-n-strong/60 bg-n-surface-1 px-3 pb-3 pt-2">
    <div
      class="grid w-full min-w-0 grid-cols-3 items-center gap-1 rounded-2xl border border-n-strong/60 bg-n-alpha-1 p-1 shadow-sm"
    >
      <button
        v-for="item in items"
        :key="item.key"
        type="button"
        class="inline-flex min-w-0 items-center justify-center gap-2 rounded-xl px-2 py-2.5 text-xs font-medium transition-colors sm:text-sm"
        :class="
          modelValue === item.key
            ? 'bg-n-surface-1 text-n-slate-12 shadow-sm ring-1 ring-n-strong/60'
            : 'text-n-slate-11 hover:bg-n-alpha-2 hover:text-n-slate-12'
        "
        @click="modelValue = item.key"
      >
        <fluent-icon :icon="item.icon" size="14" />
        <span class="truncate">{{ item.label }}</span>
      </button>
    </div>
  </div>
</template>
